import { render, staticRenderFns } from "./TermsAndCondition.vue?vue&type=template&id=428efb42"
import script from "./TermsAndCondition.vue?vue&type=script&lang=js"
export * from "./TermsAndCondition.vue?vue&type=script&lang=js"
import style0 from "./TermsAndCondition.vue?vue&type=style&index=0&id=428efb42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports